
export function showAllMarkers(properties) {
    if (!properties || properties.length === 0) return null;

    // Set the initial visible properties to show all properties
    return properties.map(property => ({ ...property, showMarker: true }));
}

export function getVisibleProperties(keyword, filters, allProperties, searchResults) {
    if (keyword === undefined
        || filters === undefined
        || !allProperties
        || allProperties.length === 0
        || !searchResults
        || searchResults.length === 0
    ) return null;
    
    // Check if keyword search or any filters are applied
    const noActiveKeyword = keyword === '';
    const noActiveFilter = Object.values(filters).every(val => val === null || val === '');
    
    return noActiveKeyword && noActiveFilter ? allProperties : searchResults;
}
